import abTests, { type GoalName } from 'frontend/shared/javascripts/modules/ab_tests'

up.compiler(
  '[data-video-ad-click-through-button]',
  (
    element: HTMLAnchorElement,
    {
      video_id: videoId,
      conversion_goal: conversionGoal,
    }: { video_id: number; conversion_goal?: string },
  ) => {
    up.on(
      'player:received-click-through-url',
      (event: Event & { videoId: number; triggerClick: () => void }) => {
        if (event.videoId === videoId) {
          element.classList.remove('d-none')
          up.emit(element, 'app.relayout')
          element.onclick = (e: Event) => {
            e.preventDefault()
            if (conversionGoal) {
              abTests.conversion(conversionGoal as GoalName)
            }
            event.triggerClick()
          }
        }
      },
    )
  },
)
